import type { FC } from 'react';
import React from 'react';
import {
  Box,
  Body,
  Col,
  Flex,
  Glyph,
} from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

import type { Stopover } from '@/components/FlightSummary/Segment/resolver';

interface ConnectionChangeTypeMapItineraryProps {
  locationChangeType: Stopover['locationChangeType'];
}

const ConnectionChangeTypeMapItinerary: FC<
  ConnectionChangeTypeMapItineraryProps
> = ({ locationChangeType }) => {
  const { t } = useTranslation();
  const keys = {
    station: 'flightSummary.itinerary.stop.selfTransfer.trainStation',
    airport: 'flightSummary.itinerary.stop.airportChange',
    terminal: 'flightSummary.itinerary.stop.terminalChange',
  };
  return locationChangeType !== 'none' ? (
    <Box pb="2x_small">
      <Flex flexDirection="row">
        <Col>
          <Glyph
            size="small"
            color="neutral.80"
            category="User"
            name="ManBaggageWalking"
          />
        </Col>
        <Col>
          <Box pl="1x_small">
            <Body type="xSmall" color="neutral.80" inline>
              {t(keys[locationChangeType])}
            </Body>
          </Box>
        </Col>
      </Flex>
    </Box>
  ) : null;
};

export default ConnectionChangeTypeMapItinerary;
